import React from 'react'
import Header from './Header'
import Contact from './Contact'
import Footer from './Footer'

const Contact_Container = () =>{
  return (
    <>
      <Header/>
      <Contact/>
      <Footer/>
    </>
  )
}

export default Contact_Container
